import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { qmsService } from '../qms.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppService } from '../../app.service';
import { SuccessSnackbarComponent } from '../../support/success-snackbar/success-snackbar.component';
import { CodeList } from '../../add-training/codeList';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { CRComponent } from '../cr/cr.component';
import { messageService } from '../../message.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { catchError, concatMap, finalize, forkJoin, from, Observable, of, tap } from 'rxjs';
import { CapaComponent } from '../capa/capa.component';
import { DvComponent } from '../dv/dv.component';
import { InComponent } from '../in/in.component';
import { CcComponent } from '../cc/cc.component';
import { OosComponent } from '../oos/oos.component';
import { TasksEcComponent } from '../tasks-ec/tasks-ec.component';
import { AuComponent } from '../au/au.component';
import { AuDetailPageComponent } from '../au/au-detail-page/au-detail-page.component';
import { QiComponent } from '../qi/qi.component';
import { TaskDocumentsComponent } from '../task-documents/task-documents.component';
import { AuService } from '../au/au.service';
import { AuQuestionsComponent } from '../au/au-questions/au-questions.component';
import { MsalService } from '@azure/msal-angular';
import { ChecklistComponent } from '../checklist/checklist.component';
import { CheckListConfig } from 'src/app/support/models/check-list.model';
import { DependencyNavigationService } from 'src/app/support/navigation/dependency-navigation.service';
import { CoreNavigationService } from 'src/app/support/navigation/core-navigation.service';


export interface FilesTab {
  docName: string,
  docExtension: string,
  comments: string
}


@Component({
  selector: 'app-activity-dynamic-button',
  templateUrl: './activity-dynamic-button.component.html',
  styleUrls: ['./activity-dynamic-button.component.scss']
})

export class ActivityDynamicButtonComponent implements OnInit {
  datepickerDateCustomClasses: DatepickerDateCustomClasses[];

  constructor(
    public auService: AuService,
    public appService: AppService,
    public qualityService: qmsService,

    private readonly router: Router,
    private readonly dialog: MatDialog,
    private readonly snackBar: MatSnackBar,
    private readonly message: messageService,
    private readonly qiComponent: QiComponent,
    private readonly cRComponent: CRComponent,
    private readonly dvComponent: DvComponent,
    public readonly auComponent: AuComponent,
    private readonly ccComponent: CcComponent,
    private readonly inComponent: InComponent,
    private readonly authService: MsalService,
    private readonly oosComponent: OosComponent,
    private readonly capaComponent: CapaComponent,
    private readonly tasksEcComponent: TasksEcComponent,
    private readonly auQuestionsComponent: AuQuestionsComponent,
    private readonly auDetailPageComponent: AuDetailPageComponent,
    private readonly taskDocumentsComponent: TaskDocumentsComponent,
    private readonly dependencyNavigationService: DependencyNavigationService,
    private readonly coreNavigationService: CoreNavigationService
  ) {
    const now = new Date();
    this.datepickerDateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  };

  buttonLabel: any;
  title: any;
  reason: any;
  isProcessing: boolean;
  snackbarRef: any;
  dependencyStatusCounter: number = 0;
  dependencyStatusList: any = [];

  isEsignRequired = false;
  isReasonSignReqd = false;
  userName: any;
  password: any = "";
  actionStatus: any;
  comments: any;
  rejectReason: any;
  isConfirmationFileValid = false;
  statusList: CodeList[] = [];
  rejectReasonList: CodeList[] = [];
  reasonForSignatureList: any = [];

  statusDropdown: any = [];
  reasonDropdown: any = [];
  rejectReasonDropdown: any = [];

  selectedStatus: any;
  selectedReason: any = [];
  selectedRejectReason: any = null;

  selectedCategoryValue: any = "";
  selectedTrainingTypeValue: any = "";
  selectedLanguageValue: any = "";
  selectedRejectReasonValue: any = "";
  selectedStatusValue: any = "";
  selectedReasonValue: any = "";
  isShowRejectReason = false;

  status: any;
  pass: any;

  buttonListWithoutStages: any;
  statusRequiredMsg: any;
  passRequiredMsg: any;
  reasonForSignatureRequiredMsg: any;
  allStatus: any = [];
  actionStatusOptions: any;
  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  visibleConfirmWithData: MatDialogRef<TemplateRef<any>>;

  @ViewChild('confirmWithDataPopup', { static: true }) confirmWithDataPopup: TemplateRef<any>;

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  rejectReasonSearchText: string = '';
  switchGroupText: string = '';

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  onStatusSelect(item: any) {
    this.selectedStatusValue = item.value;
    let status = null;
    for (const element of this.allStatus) {
      if (element.includes(item.value)) {
        let value: any = "";
        if (element.includes("/")) {
          const value1 = element.split("/");
          value = value1[1];
        } else {
          value = element;
        }
        this.statusChanges(value);
      }
    }

    this.isShowRejectReason = false;

    if (this.selectedStatusValue == 'Reviewer Requested More Info.' || this.selectedStatusValue == 'Approver Requested More Info.' || this.selectedStatusValue == 'Closure Reviewer Requested More Info.' || this.selectedStatusValue == 'Closure Approver Requested More Info.') {
      this.isReasonSignReqd = false;
    } else {
      this.isReasonSignReqd = true;
    }

    if (this.qualityService.moduleName == 'AU' && this.selectedStatusValue.includes("More Info.")) {
      this.isReasonSignReqd = false
    }

    if (this.statusFiledValue != undefined) {
      this.statusFiledValue.style.color = '#005c8a';
    }
  }

  onStatusRemoved(item: any) {
    this.selectedStatusValue = "";
    this.isShowRejectReason = false;
  }

  onRejectReasonSelect(event: any, item: any) {
    if (event.isUserInput)
      this.selectedRejectReasonValue = item?.valueExp ?? null;
  }

  onRejectReasonSelectOld(item: any) {
    this.selectedRejectReasonValue = item.valueExp;
  }

  onRejectReasonRemoved(item: any) {
    this.selectedRejectReasonValue = "";
  }

  onReasonSelect(item: any) {
    this.selectedReasonValue = item.valueExp;
    if (this.reasonForSignatureFieldValue != undefined) {
      this.reasonForSignatureFieldValue.style.color = '#005c8a';
    }
  }

  onReasonRemoved(item: any) {
    this.selectedReasonValue = "";
    if (this.reasonForSignatureFieldValue != undefined) {
      this.reasonForSignatureFieldValue.style.color = 'red';
    }
  }

  reasonForSignature: any;
  statusChanges(status: any) {
    this.reasonDropdown = [];
    this.selectedReason = [];
    this.selectedReasonValue = "";
    this.isProcessing = true;
    let data = {
      stageName: this.qualityService.activityButtonLabels.stageName,
      status: status,
      module: this.qualityService.moduleName,
    }
    if (this.qualityService.activity.status == "Pending QA Approval") {
      data.stageName = "QA Approval";
    } else if (this.qualityService.activity.status == "Pending Obsolete Approval") {
      data.stageName = "Obsolete Approval";
    }
    this.appService.getReasonForSigns(data).subscribe((data: any) => {
      this.isProcessing = false;
      this.reasonForSignatureList = data;
      for (const element of this.reasonForSignatureList) {
        this.reasonDropdown = this.reasonDropdown.concat({
          valueExp: element.reasonForSignature,
          displayExp: element.reasonForSignature
        });
      }
      if (this.reasonForSignatureList.length == 1) {
        this.reasonForSignature = this.reasonForSignatureList[0].reasonForSignature;

        this.selectedReasonValue = this.reasonForSignatureList[0].reasonForSignature;
        for (const element of this.reasonDropdown) {
          if (element.valueExp == this.reasonForSignatureList[0].reasonForSignature) {
            this.selectedReason = [{
              valueExp: element.valueExp,
              displayExp: element.displayExp
            }]
          }
        }
      }

      if (this.selectedReason.length != 0) {
        if (this.reasonForSignatureFieldValue != undefined) {
          this.reasonForSignatureFieldValue.style.color = '#005c8a';
        }
      }
    })
  }

  confirmWithDataPopupConfig = {
    width: '800px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  confirmWithReasonPopupConfig = {
    width: '525px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;

  visibleConfirm: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmPopup', { static: true }) confirmPopup: TemplateRef<any>;
  confirmPopupConfig = {
    width: this.getWidth(),
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  getWidth() {
    if (this.title?.length < 30) {
      return '550px'
    } else if (this.title?.length < 50) {
      return '650px'
    } else {
      return '800px'
    }
  }

  visibleValidationConfirm: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmValidationPopup', { static: true }) confirmValidationPopup: TemplateRef<any>;
  confirmValidationPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  switchGroupPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  visibleswitchGroupPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('switchGroupPopup', { static: true }) switchGroupPopup: TemplateRef<any>;
  dropDownDataForOutcome: any = [];
  dropDownDataForMethodology: any = [];
  dropDownDataForDocumentType: any = [];
  dropDownForOwner: any = [];
  moduleList: any = [];
  isAdEnabled = false;
  displayUserName: any;
  ngOnInit(): void {
    this.noticeTo = '';
    let userData = JSON.parse(sessionStorage.getItem("userDetails") ?? '{}')
    this.displayUserName = userData.userNameAtApplication;
    this.buttonListWithoutStages = ["Save", "Update", "Delete", "Revoke", "Obsolete", "Reject", "Reopen", "Close Complaints", "More Info. Required On Responses", "More Info. Required On Q&A Responses", "Close Complaint", "Request for Reinvestigation", "Initiate PhaseII"];

    this.isAdEnabled = localStorage.getItem("adEnabled") == 'Y';

    const codeListsRequests = [
      this.appService.getCodeListsByGroup("EFFECTIVENESS_CHECK_FOR"),
      this.appService.getCodeListsByGroup("EFFECTIVENESS_CHECK_OUTCOME"),
      this.appService.getCodeListsByGroup("EFFECTIVENESS_CHECK_METHODOLOGY"),
      this.appService.getCodeListsByGroup("DOCUMENT_TYPE"),
      this.appService.getCodeListsByGroup("MODULES"),
    ];

    forkJoin(codeListsRequests).subscribe({
      next: ([checkRequiredForData, outcomeData, methodologyData, documentTypeData, module]) => {
        this.dropDownDataForCheckRequiredFor = checkRequiredForData;
        this.dropDownDataForOutcome = outcomeData;
        this.dropDownDataForMethodology = methodologyData;
        this.dropDownDataForDocumentType = documentTypeData;
        this.moduleList = module;
        this.selectBoxForCheckRequiredFor();
        this.selectBoxForOutcome();
        this.selectBoxForMethodology();
      },
      error: () => {
        this.isProcessing = false;
      }
    });

    this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Effectiveness Check Performer').subscribe((data: any) => {
      this.dropDownForOwner = data;
      this.isProcessing = false;
      this.selectBoxForOwner();
    });
    this.appService.getGroupsModuleCurrentUserVw(this.qualityService.moduleName).subscribe((data: any) => {

      this.groupdataList = data;
      this.selectBoxeForGroupValue();
    });

    this.appService.getOneQmsOrganization().subscribe((data: any) => {
      this.orgData = data;
    })
  };

  orgData: any;
  selectBoxeForGroupValue() {
    this.groupValueDropdown = [];
    for (const element of this.groupdataList) {
      this.groupValueDropdown = this.groupValueDropdown.concat({
        valueExp: element.groupId,
        displayExp: element.groupName
      });
    }
  }


  backBtn() {
    this.qualityService.refereshBreadCrumb = false;

    if (this.coreNavigationService.navigationSource == 'Home') {
      this.router.navigate(['dashboard']);
    } else if (this.qualityService.cancelButtonFrom == "myTask") {
      if (this.qualityService.taskModuleName == "AU") {
        if (this.qualityService.auditEditmodeDatas.pageName == "Conduct Audit") {
          this.auService.tabName = null;
          this.qualityService.taskModuleName = null;
          this.qualityService.auditEditmodeDatas.pagename = null;
          this.router.navigate(['dashboard/MyTasks']);

        } else {
          this.auComponent.cancelAddAndEditFunction();
        }
      } else {
        if (this.qualityService.moduleName === 'AU') {
          this.auService.tabName = null;
          this.qualityService.taskModuleName = null;
          this.qualityService.auditEditmodeDatas.pageName = null;
        }
        this.message.showLeftMenu = "Main";
        this.router.navigate(['dashboard/MyTasks']);
      }
    } else if (this.qualityService.isTriggeredFromDependencies) {
      const previousContext = this.dependencyNavigationService.pop();
      const currentModuleName = this.qualityService.moduleName;

      if (previousContext) {
        this.qualityService.isTriggeredFromDependencies = Boolean(this.dependencyNavigationService.getStackSize());
        this.qualityService.moduleName = this.message.changeRequestCode = previousContext.moduleName;
        this.qualityService.selectedGroup = previousContext.groupId;
        this.qualityService.selectedGroupDetailData = previousContext.groupDetails;
        this.qualityService.selectedGroupDetailId = previousContext.groupDetailId;
        this.qualityService.activityId = this.message.activityId = previousContext.activityId;
        this.qualityService.moduleFullName = this.moduleList.find((x: any) => x.codelistCode == previousContext.moduleName).codelistName;
        if (previousContext.moduleName == currentModuleName) {
          this.dependencyNavigationService.refresh.emit();
        } else if (previousContext.moduleName == 'CR') {
          this.router.navigate(['dashboard/qmsCr']);
        } else if (previousContext.moduleName == 'CAPA') {
          this.router.navigate(['dashboard/capa']);
        } else if (previousContext.moduleName == 'DV') {
          this.router.navigate(['dashboard/dv']);
        } else if (previousContext.moduleName == 'IN') {
          this.router.navigate(['dashboard/in']);
        } else if (previousContext.moduleName == 'QI') {
          this.router.navigate(['dashboard/qi']);
        } else if (previousContext.moduleName == 'CC') {
          this.router.navigate(['dashboard/cc']);
        } else if (previousContext.moduleName == 'AU') {
          this.router.navigate(['dashboard/auDetailPage']);
        } else if (previousContext.moduleName == 'OOS') {
          this.router.navigate(['dashboard/oos']);
        }
      }
    } else if (this.qualityService.moduleName == "CR") {
      this.qualityService.moduleName = 'CR';
      this.router.navigate(['dashboard/ActivityCR', "CR"]);
    } else if (this.qualityService.moduleName == "CAPA") {
      this.qualityService.moduleName = 'CAPA';
      this.router.navigate(['dashboard/ActivityCR', "CAPA"]);
    } else if (this.qualityService.moduleName == "DV") {
      this.qualityService.moduleName = 'DV';
      this.router.navigate(['dashboard/ActivityCR', "DV"]);
    } else if (this.qualityService.moduleName == "IN") {
      this.qualityService.moduleName = 'IN';
      this.router.navigate(['dashboard/ActivityCR', "IN"]);
    } else if (this.qualityService.moduleName == "QI") {
      this.qualityService.moduleName = 'QI';
      this.router.navigate(['dashboard/ActivityCR', "QI"]);
    } else if (this.qualityService.moduleName == "CC") {
      this.qualityService.moduleName = 'CC';
      this.router.navigate(['dashboard/ActivityCR', "CC"]);
    } else if (this.qualityService.moduleName == "OOS") {
      this.qualityService.moduleName = 'OOS';
      this.router.navigate(['dashboard/ActivityCR', "OOS"]);
    } else if (this.qualityService.moduleName == "AU") {
      this.qualityService.moduleName = 'AU';
      if (this.qualityService.auditEditmodeDatas.pageName == "Conduct Audit") {
        this.router.navigate(['dashboard/au']);
      } else {
        this.auComponent.cancelAddAndEditFunction();
      }
    }
  }

  fileExtn: any;
  buttonOperationFile: any;
  fileName: string = '';
  onConfirmFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.buttonOperationFile = file;
      this.fileName = file.name.substring(0, file.name.lastIndexOf('.'));
      this.fileExtn = (file.name.split('.').pop() ?? '').toLowerCase();
      let name = file.name.substring(0, file.name.lastIndexOf('.'));
      const formData = new FormData();
      formData.append('file', file ?? '');
      formData.append("pageName", "QMS");
      formData.append("fileName", name);
      formData.append("extension", this.fileExtn);
      this.isProcessing = true;
      this.appService.fileUploadToServer(formData).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.isConfirmationFileValid = true;
          } else {
            this.isConfirmationFileValid = false;
            this.showSnackBar(data.result, data.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  @ViewChild('addPopup', { static: true }) addPopup: TemplateRef<any>;
  visibleAddPopup: MatDialogRef<TemplateRef<any>>;
  addPopupConfig = {
    width: '50%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  updateData: any = {};
  idflexiFieldValue: any;
  mandatoryFieldNull: boolean;
  scrollToMasdatoryField: any;
  scrollToMandatoriesField(value: any) {
    this.scrollToMasdatoryField = document.getElementById(value) as HTMLInputElement;
    setTimeout(() => this.scrollToMasdatoryField.scrollIntoView(), 0);
  }

  method1(value: any) {
    let returndata: boolean = false;
    for (const element of this.qualityService.activityDynamicButtonList) {
      if ((value == 'Submit' && element.includes('Submit'))) {
        if (!element.includes('Accept') && !element.includes('Review') && !element.includes('Approve')) {
          returndata = true;
        }
      } else if (element.includes(value)) {
        returndata = true;
      }
    }
    return returndata;
  }

  activityIndexOfBtn(value: any) {
    for (const element of this.qualityService.activityDynamicButtonList) {
      if (element.includes(value)) {
        this.dynamicButtonClick(element);
        break;
      }
    }
  }

  tooltipText: any;
  toolTip(value: any) {
    this.tooltipText = "";
    for (const element of this.qualityService.activityDynamicButtonList) {
      if (element.includes(value)) {
        this.tooltipText = element;
        console.log(this.tooltipText);
      }
    }
  }

  noticeTo: string = '';
  triggerSave() {
    if (this.noticeTo == 'Actions') {
      this.qualityService.activity.actionItemsReqd = false;
    }

    if (this.noticeTo == 'Risk') {
      this.qualityService.activity.isRiskCalculationReqd = false;
    }

    if (this.noticeTo == 'Products') {
      this.qualityService.activity.isProductComplaint = false;
      this.qualityService.activity.isInvestigationReqd = false;
      this.qualityService.ccDropDowns.selectedInvestigator = null;
    }

    const saveMapping = {
      CR: 'cRComponent',
      CAPA: 'capaComponent',
      DV: 'dvComponent',
      IN: 'inComponent',
      QI: 'qiComponent',
      CC: 'ccComponent',
      AU: 'auDetailPageComponent'
    } as const;

    type ModuleKey = keyof typeof saveMapping;

    (this[saveMapping[this.qualityService.moduleName as ModuleKey]] as { update: () => any }).update();


    this.visibleNoticePopup.close();
  }

  @ViewChild('noticePopup', { static: true }) noticePopup: TemplateRef<any>;
  visibleNoticePopup: MatDialogRef<TemplateRef<any>>;

  noticePopupConfig = {
    width: '690px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  closeNoticePopup() {
    this.visibleNoticePopup.close();
  }

  private async validateDependencies(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      (this.appService.getDependenciesListByRefNo(this.qualityService.activityId) as Observable<any[]>).subscribe({
        next: (data: any[]) => {
          [this.dependencyStatusList, this.dependencyStatusCounter] = [[], 0];

          if (data.length > 0) {
            data.forEach((item: any, index: number, array: any[]) => {
              if (!['Closed', 'Deleted', 'Obsoleted', 'Evaluation Rejected - Closed', 'Complaint Rejected - Closed'].includes(item.dependentTaskStatus)) {
                this.dependencyStatusCounter++;
                this.dependencyStatusList.push(item);
              }

              if (index === array.length - 1) {
                if (this.dependencyStatusCounter > 0) {
                  this.visibledDependencyAlertPopup = this.dialog.open(this.dependencyAlertPopup, this.dependencyAlertPopupPopupConfig);
                  this.title = 'Dependency Alert';
                  this.isProcessing = false;
                  resolve(false); //  Cannot proceed
                } else {
                  resolve(true);  //  Safe to proceed
                }
              }
            });
          } else {
            resolve(true); //  No dependencies at all
          }
        },
        error: (err) => {
          console.error('Error fetching dependencies:', err);
          this.isProcessing = false;
          reject(new Error(err));
        }
      });
    });
  }

  async checkActionsHasData(): Promise<boolean> {
    this.isProcessing = true;
    return new Promise((resolve, reject) => {
      this.appService.getQmsActionByRefNo(this.qualityService.activityId).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          !data.length && (this.noticeTo = 'Actions') && (this.visibleNoticePopup = this.dialog.open(this.noticePopup, this.noticePopupConfig));
          resolve(data?.length > 0);
        },
        error: (err) => {
          this.isProcessing = false;
          console.error('Error:', err);
          reject(new Error(err));
        }
      });
    });
  }

  async checkProductsHasData(): Promise<boolean> {
    this.isProcessing = true;
    return new Promise((resolve, reject) => {
      this.appService.getAllProductsByCcNo(this.qualityService.activityId).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          !data.length && (this.noticeTo = 'Products') && (this.visibleNoticePopup = this.dialog.open(this.noticePopup, this.noticePopupConfig));
          resolve(data?.length > 0);
        },
        error: (err) => {
          this.isProcessing = false;
          console.error('Error:', err);
          reject(new Error(err));
        }
      });
    });
  }

  waitForObjectReady(checkFn: () => boolean, timeout = 10000, interval = 100): Promise<void> {
    return new Promise((resolve, reject) => {
      const start = Date.now();
      const timer = () => {
        if (checkFn()) {
          resolve();
        } else if (Date.now() - start >= timeout) {
          reject(new Error('Timeout: activity not fully populated.'));
        } else {
          setTimeout(timer, interval);
        }
      };
      timer();
    });
  }

  stageUserStageDetails: any;
  private getStageUserDetails(activityId: number, version: number, stageName: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.isProcessing = true;
      this.appService.getRoleOfUserForSignoff(activityId, version, stageName.split('<')[0]).subscribe({
        next: (stageUser: any) => {
          this.stageUserStageDetails = stageUser;
          console.log('this.stageUserStageDetails...', stageUser);
          resolve(stageUser);
        },
        error: (err) => {
          console.error('Error fetching stage user details', err);
          reject(err);
        }
      });
    });
  }

  isCheckListEnabled: boolean = false;
  isCheckListSkippable: boolean = false;
  isSkipped: boolean = false;
  isVerifyingCheckList: boolean = false;
  async dynamicButtonClick(button: string) {

    console.log('this.qualityService.moduleName', this.qualityService);

    const module = this.qualityService.moduleName;
    const status = this.qualityService.activity.status;
    const groupDetails = this.qualityService.selectedGroupDetailData;
    const stageName = this.qualityService.activityButtonLabels.stageName?.split('<')[0];
    const x = this.qualityService.selectedGroupDetailData;

    this.isCheckListEnabled = this.qualityService.selectedGroupDetailData.enableCheckList == 'Y' && (((stageName == 'Review' || stageName == 'Peer Review' || stageName == 'PhaseII Review' || stageName == 'PhaseIII Review') && x.reviewCheckListTemplateIds) || ((stageName == 'Approve' || stageName == 'PhaseIII Review' || stageName == 'PhaseIII Approve') && x.approveCheckListTemplateIds) || (stageName == 'Closure Review' && x.closureReviewCheckListTemplateIds) || (stageName == 'Closure Approve' && x.closureApproveCheckListTemplateIds));
    this.isCheckListSkippable = this.isCheckListEnabled && this.qualityService.selectedGroupDetailData.isCheckListSkippable == 'Y';
    this.isSkipped = false;
    this.fileName = '';

    this.noticeTo = '';

    const moduleKey = module as keyof typeof processMapping;

    const saveMapping =
      { 'CR': 'cRComponent', 'CAPA': 'capaComponent', 'DV': 'dvComponent', 'IN': 'inComponent', 'QI': 'qiComponent', 'CC': 'ccComponent' } as const;
    const processMapping =
      { 'CR': 'isUpdatingCrThroughDynBtn', 'CAPA': 'isUpdatingCapaThroughDynBtn', 'DV': 'isUpdatingDvThroughDynBtn' } as const;

    if ((button == 'Review' || button == 'Approve') && this.isCheckListEnabled && ['Pending Review', 'Review Inprogress', 'Pending Approval', 'Approval Inprogress', 'Pending Closure Review', 'Closure Review Inprogress', 'Pending Closure Approval', 'Closure Approval Inprogress', 'Pending Peer Review', 'Peer Review Inprogress', 'Pending PhaseII Review', 'PhaseII Review InProgress', 'Pending PhaseIII Review', 'PhaseIII Review InProgress'].includes(status)) {
      this.isVerifyingCheckList = true;
      await this.getStageUserDetails(this.qualityService.activityId, 0, this.qualityService.activityButtonLabels.stageName);
    }

    if (button == "Cancel") {
      this.backBtn();
    } else {
      this.qualityService.saveDataUsingDynamicButtons = false;
      this.isReasonSignReqd = false;
      this.selectedStatusValue = null;
      this.comments = "";
      this.selectedRejectReasonValue = null;
      this.selectedReasonValue = "";
      this.buttonLabel = button;
      this.qualityService.clickedButton = this.buttonLabel;
      this.isEsignRequired = false;
      this.changeTypeAddAndEditPassword = true;
      this.userName = localStorage.getItem("loggedUserName");
      if (this.qualityService.activityButtonLabels.stageName != null) {
        this.isReasonSignReqd = true;
      } else if (this.qualityService.activity.status == "Pending QA Approval" ||
        this.qualityService.activity.status == "Pending Obsolete Approval") {
        this.isReasonSignReqd = true;
      } else if (this.qualityService.activity.status == "Pending Delete Approval"
        || this.qualityService.activity.status == "Pending Revoke Approval"
        || this.qualityService.activity.status == "Pending Reopen Approval") {
        this.isReasonSignReqd = false;
      } else {
        this.isReasonSignReqd = false;
      }

      if (button.includes("Delete") || button.includes("Obsolete") || button.includes("Accept") || button.includes("Mark")
        || button.includes("Acknowledge") || button.includes("Submit") || button.includes("Required") || button.includes("Close")) {
        this.isEsignRequired = true;
      }
      if (button == "Save" && this.qualityService.moduleName == "CR") {
        this.cRComponent.update();
      } else if (button == "Save" && this.qualityService.moduleName == "CAPA") {
        this.capaComponent.update();
      } else if (button == "Save" && this.qualityService.moduleName == "DV") {
        this.dvComponent.update();
      } else if (button == "Save" && this.qualityService.moduleName == "IN") {
        this.triggerIncidentUpdate();
      } else if (button == "Save" && this.qualityService.moduleName == "QI") {
        this.triggerQiUpdate();
      } else if (button == "Save" && this.qualityService.moduleName == "CC") {
        this.triggerCcUpdate();
      } else if (button == "Save" && this.qualityService.moduleName == "OOS") {
        this.triggerOosUpdate();
      } else if (button == "Save" && this.qualityService.moduleName == "AU") {
        this.callQmsAuVwUpdateFunction();
      } else if (button == "Add New Plan") {
        this.auComponent.createNewPlan();
      } else if ((module == 'CR' || module == 'CAPA' || module == 'DV') && (button == "Submit to Owner" || button == "Re-Submit to Owner" || button == "Submit to QA(Acceptance)" || button == "Re-Submit to QA(Acceptance)" || button == "Submit for Department Head Approval" || button == 'Re-Submit for Department Head Approval' || button == 'Approve and Submit to QA.' || button == "Submit to QA(Approval)" || button == "Re-Submit to QA(Approval)" || button == "Mark Inprogress" || button == "Submit for Review" || button == "Re-Submit for Review" || button == "Re-Submit for Approval" || button == "Submit for Approval" || (button == 'Accept' && (status == 'Pending QA Acceptance' && groupDetails.editableByQA == 'Y')))) {

        this.qualityService[processMapping[moduleKey]] = true;

        if (button == "Submit to QA(Approval)" || button == "Re-Submit to QA(Approval)" || button == "Mark Inprogress" || button == "Submit for Review" || button == "Re-Submit for Review" || button == "Re-Submit for Approval" || button == "Submit for Approval") {
          try {
            const result = await this[saveMapping[moduleKey]].update();
            if (!result) return;

            await this.waitForObjectReady(() => {
              const details = this.qualityService.activity;
              return !!(details?.status && details?.createdOn != null);
            }, 5000);

            if (this.qualityService.activity.actionItemsReqd) {
              const action = await this.checkActionsHasData();
              if (!action) return;
            }

            if (!this.qualityService.activity.finalRiskScore && this.qualityService.activity.isRiskCalculationReqd) {
              this.noticeTo = 'Risk';
              this.visibleNoticePopup = this.dialog.open(this.noticePopup, this.noticePopupConfig);
              return;
            }

            this.triggerDefaultPopup(button);
          } catch (error) {
            console.error('Error during CR dynamic button flow:', error);
          } finally {
            this.isProcessing = false;
          }
        } else {
          const result = await this[saveMapping[moduleKey]].update();
          if (!result) return;
          this.triggerDefaultPopup(button);
        }

      } else if (button == "Obsolete" || button == "Inactivate" || button == "Delete" || button == "Activate" || button == "Update") {
        this.title = button;
        this.reason = null;
        this.isEsignRequired = true;
        this.updateData = this.qualityService.activity;

        delete this.updateData.obsoleteApprovedOn;
        delete this.updateData.obsoleteRequestedOn;
        delete this.updateData.ownerApprovedOn;
        delete this.updateData.qaApprovalRequestedOn;
        delete this.updateData.qaApprovedOn;
        delete this.updateData.reopenApprovedOn;
        delete this.updateData.reopenRequestedOn;
        delete this.updateData.updatedOn;
        this.password = "";
        this.comments = "";
        this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);

      } else if (button == "Review" || button == "Approve" || button == "Reject" || button == "Obsolete" || button == 'Peer Review') {
        this.password = "";
        this.comments = "";
        this.statusDropdown = [];
        this.rejectReasonDropdown = [];

        this.selectedReason = [];
        this.selectedStatus = null;
        this.selectedRejectReason = null;
        this.selectedReasonValue = "";
        this.selectedStatusValue = "";
        this.selectedRejectReasonValue = "";
        this.reasonDropdown = [];
        this.actionStatusOptions = this.qualityService.activityButtonLabels.actionStatusOptions;
        this.allStatus = [];
        let data1 = [];
        if (this.actionStatusOptions != null) {
          data1 = this.actionStatusOptions.split(",");
          this.allStatus = this.actionStatusOptions.split(",");
          for (let k = 0; k < this.allStatus.length; k++) {
            this.allStatus[k] = this.allStatus[k].trim();
          }
        }

        this.statusList = [];
        for (let i = 0; i < data1.length; i++) {
          data1[i] = data1[i].trim();
          let data2 = data1[i].split("/");
          if (data2.length > 1) {
            this.statusList.push({ codelistCode: data2[1].trim(), codelistName: data2[0].trim() });
          } else {
            this.statusList.push({ codelistCode: data2[0].trim(), codelistName: data2[0].trim() });
          }

        }
        for (const element of this.statusList) {
          this.statusDropdown = this.statusDropdown.concat({
            valueExp: element.codelistCode,
            displayExp: element.codelistName
          });
        }
        this.isProcessing = true;
        const rejectReasonKey = module === 'IN' ? 'INCIDENT_REJECT_REASON' : module + '_REJECT_REASON';
        this.appService.getCodeListsByGroup(rejectReasonKey).subscribe((data: any) => {
          this.rejectReasonList = data;
          this.isProcessing = false;
          for (const element of this.rejectReasonList) {
            this.rejectReasonDropdown = this.rejectReasonDropdown.concat({
              valueExp: element.codelistCode,
              displayExp: element.codelistName
            });
          }
        })
        this.isProcessing = true;
        if (this.qualityService.activity.status == "Pending Obsolete Approval") {
          this.isEsignRequired = true;
          this.isProcessing = false;
          this.isReasonSignReqd = true;
          this.confirmWithDataPopupConfig.width = '650px';
          this.buttonOperationFile = null;
          this.fileExtn = '';
          this.visibleConfirmWithData = this.dialog.open(this.confirmWithDataPopup, this.confirmWithDataPopupConfig);
        } else if (this.qualityService.activity.status == "Pending Delete Approval" || this.qualityService.activity.status == "Pending Revoke Approval" || this.qualityService.activity.status == "Pending Reopen Approval") {
          this.isEsignRequired = true;
          this.isProcessing = false;
          this.isReasonSignReqd = false;
          this.confirmWithDataPopupConfig.width = this.isReasonSignReqd ? '600px' : '500px';
          this.buttonOperationFile = null;
          this.fileExtn = '';
          this.visibleConfirmWithData = this.dialog.open(this.confirmWithDataPopup, this.confirmWithDataPopupConfig);
        } else if (button == "Reject") {
          this.isEsignRequired = true;
          this.isProcessing = false;
          if (this.qualityService.activity.status == "Raised" && (module == "IN" || module == "QI" || module == "CC")) {
            this.isShowRejectReason = true;
          } else {
            this.isShowRejectReason = false;
          }

          this.isReasonSignReqd = this.qualityService.activity.status == 'Pending QA Approval';
          this.confirmWithDataPopupConfig.width = this.isReasonSignReqd ? '600px' : '500px';
          this.buttonOperationFile = null;
          this.fileExtn = '';
          this.visibleConfirmWithData = this.dialog.open(this.confirmWithDataPopup, this.confirmWithDataPopupConfig);
        } else {
          if ((button == "Approve" && module == "AU") || this.qualityService.activityButtonLabels.stageName == null) {
            this.isEsignRequired = true;
          }
          this.appService.getModuleStages(module, this.qualityService.activityButtonLabels.stageName)
            .subscribe((data: any) => {
              this.isProcessing = false;
              if (data.length > 0) {
                if (data[0].esignReqd == "Y") {
                  this.isEsignRequired = true;
                }
                if (data[0].reasonForSignatureReqd == "Y") {
                  this.isReasonSignReqd = true;
                }
              }
            });

          this.buttonOperationFile = null;
          this.fileExtn = '';
          if ((module == 'CR' || module == 'CAPA' || module == 'DV' || module == 'IN' || module == 'QI' || module == 'CC') && (button == 'Approve' || button == 'Review')) {

            if ((status == 'Pending QA Approval' && groupDetails.editableByQA == 'Y') || ((status == 'Pending Review' || status == 'Review Inprogress') && groupDetails.editableByReviewers == 'Y') || ((status == 'Pending Approval' || status == 'Approval Inprogress') && groupDetails.editableByApprovers == 'Y')) {
              try {
                const result = await this[saveMapping[moduleKey]].update();
                if (!result) return;

                await this.waitForObjectReady(() => {
                  const details = this.qualityService.activity;
                  return !!(details?.status && details?.createdOn != null);
                }, 10000);

                if (this.qualityService.activity.actionItemsReqd) {
                  const action = await this.checkActionsHasData();
                  if (!action) return;
                }

                if (module == "CC" && this.qualityService.activity.isProductComplaint) {
                  const product = await this.checkProductsHasData();
                  if (!product) return;
                }

                if (!this.qualityService.activity.finalRiskScore && this.qualityService.activity.isRiskCalculationReqd) {
                  this.noticeTo = 'Risk';
                  this.visibleNoticePopup = this.dialog.open(this.noticePopup, this.noticePopupConfig);
                  return;
                }

                this.visibleConfirmWithData = this.dialog.open(this.confirmWithDataPopup, this.confirmWithDataPopupConfig);
              } catch (error) {
                console.error('Error during CR dynamic button flow:', error);
              } finally {
                this.isProcessing = false;
              }
            } else if (status == 'Pending Closure Review' || status == 'Closure Review Inprogress' || status == 'Pending Closure Approval' || status == 'Closure Approval Inprogress') {
              if (await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Activity" })) {
                setTimeout(() => {
                  this.showSnackBar(this.qualityService.extensionResult, 'E');
                }, 0);
              } else {
                this.qualityService[processMapping[moduleKey]] = true;
                const result = await this[saveMapping[moduleKey]].update();
                if (!result) return;

                await this.waitForObjectReady(() => {
                  const details = this.qualityService.activity;
                  return !!(details?.status && details?.createdOn != null);
                }, 5000);

                this.visibleConfirmWithData = this.dialog.open(this.confirmWithDataPopup, this.confirmWithDataPopupConfig);
              }
            } else {
              this.qualityService[processMapping[moduleKey]] = true;
              const result = await this[saveMapping[moduleKey]].update();
              if (!result) return;

              await this.waitForObjectReady(() => {
                const details = this.qualityService.activity;
                return !!(details?.status && details?.createdOn != null);
              }, 5000);

              this.visibleConfirmWithData = this.dialog.open(this.confirmWithDataPopup, this.confirmWithDataPopupConfig);
            }
          }
          else {
            this.visibleConfirmWithData = this.dialog.open(this.confirmWithDataPopup, this.confirmWithDataPopupConfig);
          }
        }

      } else if (button == "Perform Effectiveness Check") {
        this.popupDataTitle = "Create Effectiveness Check";
        this.selectedCheckRequiredFor = [];
        this.selectedOwner = [];
        this.ecData.dueDate = null;
        this.ecData.remindNDaysBeforeDueDate = '';
        this.visibleAddPopup = this.dialog.open(this.addPopup, this.addPopupConfig);

      } else if (button == "Switch Group") {
        this.popupDataTitle = "Switch Group";
        this.selectedGroupValue = null;
        this.visibleswitchGroupPopup = this.dialog.open(this.switchGroupPopup, this.switchGroupPopupConfig);

      } else if ((module == "IN" || module == "QI" || module == "CC") && (button == "Submit" || button == "Log Incident" || button == "Log Quality Issue" || button == "Log Complaint" || button == "Send for Investigation" || button == "Complete Investigation" || button == "Submit to QA" || button == "Re-Submit to QA" || button == "Submit for Review" || button == "Submit for Approval" || button == "Mark Inprogress" || button == 'Re-Submit for Review' || button == 'Re-Submit for Approval')) {

        if (button == "Submit") {
          const result = await this[saveMapping[moduleKey]].update();
          if (!result) return;
          this.triggerDefaultPopup(button);
        } else {

          try {
            const result = await this[saveMapping[moduleKey]].update();
            if (!result) return;

            await this.waitForObjectReady(() => {
              const details = this.qualityService.activity;
              return !!(details?.status && details?.createdOn != null);
            }, 5000);

            if ((module != "QI" && this.qualityService.activity.actionItemsReqd) || (module == "QI" && this.qualityService.activity.actionItemsReqd && button != "Log Quality Issue" && button != "Send for Investigation" && button != "Complete Investigation")) {
              const action = await this.checkActionsHasData();
              if (!action) return;
            }

            if (module == "CC" && this.qualityService.activity.isProductComplaint) {
              const product = await this.checkProductsHasData();
              if (!product) return;
            }

            if (!this.qualityService.activity.finalRiskScore && this.qualityService.activity.isRiskCalculationReqd) {
              this.noticeTo = 'Risk';
              this.visibleNoticePopup = this.dialog.open(this.noticePopup, this.noticePopupConfig);
              return;
            }

            this.triggerDefaultPopup(button);
          } catch (error) {
            console.error('Error during dynamic button flow:', error);
          } finally {
            this.isProcessing = false;
          }
        }
      } else if ((module == "CR" || module == "CAPA" || module == "DV" || module == "IN" || module == "QI" || module == "CC") && (button == "Submit for Closure Review" || button == "Submit for Closure Approval" || button == "Close")) {

        if (await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Activity" })) {
          setTimeout(() => {
            this.showSnackBar(this.qualityService.extensionResult, 'E');
          }, 0);
        } else {
          try {
            const result = await this[saveMapping[moduleKey]].update();
            if (!result) return;

            await this.waitForObjectReady(() => {
              const details = this.qualityService.activity;
              return !!(details?.status && details?.createdOn != null);
            }, 5000);

            if (this.qualityService.activity.actionItemsReqd) {
              const action = await this.checkActionsHasData();
              if (!action) return;
            }

            if (module == "CC" && this.qualityService.activity.isProductComplaint) {
              const product = await this.checkProductsHasData();
              if (!product) return;
            }

            if (!this.qualityService.activity.finalRiskScore && this.qualityService.activity.isRiskCalculationReqd) {
              this.noticeTo = 'Risk';
              this.visibleNoticePopup = this.dialog.open(this.noticePopup, this.noticePopupConfig);
              return;
            }

            this.dependencyTriggredButton = button;
            const depCheckResult = await this.validateDependencies();
            if (!depCheckResult) return;

            this.triggerDefaultPopup(button);

          } catch (error) {
            console.error('Error during dynamic button flow:', error);
          } finally {
            this.isProcessing = false;
          }
        }
      } else if (module == "OOS" && (button == "Submit for Department Head Approval" || button == "Submit to QA(Acceptance)" || button == "Submit for Review" || button == "Submit for Approval" || button == "Mark Inprogress" || button == 'Re-Submit for Review' || button == 'Re-Submit for Approval')) {
        this.validateOos(button).then((isValid: boolean) => {
          if (isValid) {
            this.qualityService.isUpdatingOosThroughDynBtn = true;
            this.oosComponent.update();
            this.title = button;
            this.password = "";
            this.visibleConfirm = this.dialog.open(this.confirmPopup, this.confirmPopupConfig);
          } else {
            this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
          }
        })
      } else if (module == "OOS" && (button == "Submit for Closure Review" || button == "Submit for Closure Approval" || button == "Close")) {
        if (await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Activity" })) {
          setTimeout(() => {
            this.showSnackBar(this.qualityService.extensionResult, 'E');
          }, 0);
        } else {
          this.validateOos(button).then((isValid: boolean) => {
            if (isValid) {
              this.isProcessing = true;
              this.appService.getDependenciesListByRefNo(this.qualityService.activityId).subscribe((data: any) => {
                [this.dependencyStatusList, this.dependencyStatusCounter] = [[], 0];
                if (data.length > 0) {
                  data.forEach((item: any, index: number, array: any[]) => {
                    if (item.dependentTaskStatus != 'Closed' && item.dependentTaskStatus != 'Deleted' && item.dependentTaskStatus != 'Obsoleted') {
                      this.dependencyStatusCounter++;
                      this.dependencyStatusList.push(item);
                    }
                    if (index === array.length - 1) {
                      if (this.dependencyStatusCounter > 0) {
                        this.dependencyTriggredButton = button;
                        this.visibledDependencyAlertPopup = this.dialog.open(this.dependencyAlertPopup, this.dependencyAlertPopupPopupConfig);
                        this.title = button;
                        this.isProcessing = false;
                      } else {
                        this.qualityService.isUpdatingOosThroughDynBtn = true;
                        this.qiComponent.update();
                        this.isProcessing = false;
                        this.triggerDefaultPopup(button);
                      }
                    }
                  })
                } else {
                  this.qualityService.isUpdatingQiThroughDynBtn = true;
                  this.oosComponent.update();
                  this.isProcessing = false;
                  this.triggerDefaultPopup(button);
                }
              })
            } else {
              this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
            }
          })
        }
      } else if (module == "AU" && (button == "Submit for Peer Review" || button == "Send to Auditee(To Address Findings)" || button == "Re-Submit for Peer Review")) {
        if (await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Activity" })) {
          setTimeout(() => {
            this.showSnackBar(this.qualityService.extensionResult, 'E');
          }, 0);
        } else if (this.qualityService.activity.questionAndAnswerSectionType && this.qualityService.auQuestionarie.length) {
          let auditorComments = 0;
          let statusCount = 0;
          for (let obj of this.auService.questionnaireList) {
            if (!obj.auditorComments) auditorComments++;
            if (!obj.selectedReviewStatus || obj.selectedReviewStatus === 'Pending') statusCount++;
          }
          if (auditorComments || statusCount) {
            setTimeout(() => {
              this.showSnackBar("Please review the Questionnaire", "E")
            }, 100);
          } else {
            this.qualityService.isUpdatingAUThroughDynBtn = true;
            this.auQuestionsComponent.saveButton();

            if (this.qualityService.auFindingsList.length) {
              this.triggerDefaultPopup(button);
            } else {
              this.password = "";
              this.title = button;
              this.visibleValidationConfirm = this.dialog.open(this.confirmValidationPopup, this.confirmValidationPopupConfig);
            }
          }
        } else if (!this.qualityService.activity.finalRiskScore && this.qualityService.activity.isRiskCalculationReqd && this.qualityService.auFindingsList.some((finding: any) => !finding.finalRiskScore)) {
          this.noticeTo = 'Risk';
          this.visibleNoticePopup = this.dialog.open(this.noticePopup, this.noticePopupConfig);
          return;
        } else if (!this.qualityService.activity.questionAndAnswerSectionType && !this.qualityService.auFindingsList.length) {
          this.password = "";
          this.title = button;
          this.visibleValidationConfirm = this.dialog.open(this.confirmValidationPopup, this.confirmValidationPopupConfig);
        } else {
          this.triggerDefaultPopup(button);
        }
      } else if (module == "AU" && (button == "Submit for Closure Review" || button == "Submit for Closure Approval" || button == "Close")) {
        if (await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Activity" })) {
          setTimeout(() => {
            this.showSnackBar(this.qualityService.extensionResult, 'E');
          }, 0);
        } else {
          this.isProcessing = true;
          this.appService.getDependenciesListByRefNo(this.qualityService.activityId).subscribe((data: any) => {
            [this.dependencyStatusList, this.dependencyStatusCounter] = [[], 0];
            if (data.length > 0) {
              data.forEach((item: any, index: number, array: any[]) => {
                if (item.dependentTaskStatus != 'Closed' && item.dependentTaskStatus != 'Deleted' && item.dependentTaskStatus != 'Obsoleted') {
                  this.dependencyStatusCounter++;
                  this.dependencyStatusList.push(item);
                }
                if (index === array.length - 1) {
                  if (this.dependencyStatusCounter > 0) {
                    this.dependencyTriggredButton = button;
                    this.visibledDependencyAlertPopup = this.dialog.open(this.dependencyAlertPopup, this.dependencyAlertPopupPopupConfig);
                    this.title = button;
                    this.isProcessing = false;
                  } else {
                    this.triggerDefaultPopup(button);
                    this.isProcessing = false;
                  }
                }
              })
            } else {
              this.isProcessing = false;
              this.triggerDefaultPopup(button);
            }
          })
        }
      } else if (module == "AU" && (button == 'Submit for Approval(Schedule)' || button == 'Submit for Approval(Plan)' || button == 'Re-Submit for Approval(Schedule)' || button == 'Re-Submit for Approval(Plan)')) {
        this.validateAudit(button).then((isValid: boolean) => {
          if (isValid) {
            this.isProcessing = false;
            this.qualityService.isUpdatingAuThroughDynBtn = true;
            this.auComponent.addAndEditFunction();
            this.mandatoryFieldNull = false;
            this.triggerDefaultPopup(button);
          } else {
            this.isProcessing = false;
            this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
          }
        })
      } else if (module == 'AU' && (button == "Send Q&A Response" || button == "More Info. Required On Q&A Responses")) {
        //|| button == "Start Audit"
        if (this.auService.questionnaireList.length > 0) {
          console.log(this.auService.questionnaireList);

          let responseMandatoryValidation = false;
          for (const element of this.auService.questionnaireList) {
            let obj = element;
            delete obj.updatedOn;
            delete obj.createdOn;

            if (obj.selectedFlexifieldValue != undefined) {
              if (obj.fieldTypeCode == 'Drop Down') {
                obj.response = null;
                if (obj.selectedFlexifieldValue) {
                  obj.response = obj.selectedFlexifieldValue
                }
              }
              else if (obj.fieldTypeCode == 'Multiselect Drop Down') {
                obj.response = "";
                if (obj.selectedFlexifieldValue.length > 0) {
                  for (let q = 0; q < obj.selectedFlexifieldValue.length; q++) {
                    obj.response += obj.selectedFlexifieldValue;
                    obj.response += q == obj.selectedFlexifieldValue.length - 1 ? "" : ",";
                  }
                }
              }
            }
            if (obj.selectedReviewStatus != undefined) {
              obj.status = null;
              if (obj.selectedReviewStatus) {
                obj.status = obj.selectedReviewStatus
              }
            }
            if (obj.fieldTypeCode == 'Date Field') {
              if (obj.fieldTypeCode) {
                obj.response = new Date(obj.fieldValues);
              } else {
                obj.response = null
              }

            }
            if ((obj.fieldTypeCode == "Check Box")) {
              let checkedValues = [];
              for (let checkedObj of obj.fieldValuesList) {
                if (checkedObj.checked) {
                  checkedValues.push(checkedObj.name);
                }
              }
              obj.response = checkedValues.join(",");

            }

            if (obj.fieldTypeCode == "Text Field" || obj.fieldTypeCode == "Large Text Field") {
              obj.response = obj.fieldValues;
            }

            if (this.auService.isAuditee) {
              if (((obj.response == null || obj.response == "") && obj.fieldTypeCode != "Heading")) {
                responseMandatoryValidation = true;
              };
            } else if (this.auService.isAuditor && this.auService.tabName == 'Conduct Audit') {
              if ((!obj.selectedReviewStatus || obj.selectedReviewStatus == "Pending") || (!obj.auditorComments)) {
                responseMandatoryValidation = true;
              }
            }

            ;
          }
          if (responseMandatoryValidation) {
            setTimeout(() => {
              if (this.auService.isAuditee) {
                this.showSnackBar("Please respond to all the Questionnaire", "E");
              } else {
                this.showSnackBar("Please review all the Questionnaire", "E");
              }
            }, 100);
          } else {
            this.triggerDefaultPopup(button);
          }
        } else {
          this.triggerDefaultPopup(button);
        }
      } else if (button == "Submit for PhaseII Review" || button == "Submit for PhaseIII Review") {
        let phaseCounter: number = 0;
        this.isProcessing = true;
        this.appService.getAllOosActionsByRefNo(this.qualityService.activity.oosNo).subscribe((data: any) => {
          this.isProcessing = false;
          if (data.length) {
            for (let action of data) {
              if ((button == "Submit for PhaseII Review" && action.phase == 'II') || action.phase == 'III') {
                phaseCounter++
              }
            }
            if (phaseCounter) {
              this.triggerDefaultPopup(button);
            } else {
              this.showSnackBar("Minimum one Action required !", "E")
            }
          } else {
            this.showSnackBar("Minimum one Action required !", "E");
          }
        })
      } else if (button?.trim() == "Send to Auditee") {
        if (await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Activity" })) {
          setTimeout(() => {
            this.showSnackBar(this.qualityService.extensionResult, 'E');
          }, 0);
        } else {
          this.triggerDefaultPopup(button);
        }
      } else {
        this.triggerDefaultPopup(button);
      }

      if (status == "Pending QA Approval" || status == "Pending Obsolete Approval") {
        if (button == "Approve") {
          this.statusChanges("Approval Completed");
        } else if (button == "Reject") {
          this.statusChanges("Approval Rejected");
        } else if (button == "More Info. Reqd") {
          this.statusChanges("More Info. Required/QA Requested More Info.");
        }
      }
    }
  }

  triggerDefaultPopup(button: any) {
    this.isEsignRequired = true;
    this.title = button;
    this.password = "";
    this.visibleConfirm = this.dialog.open(this.confirmPopup, this.confirmPopupConfig);
  }

  popupDataTitle: any;
  selectedOwner: any = [];
  ecData: any = {};
  selectedCheckRequiredFor: any = [];
  selectedCheckRequiredForDisplayExp: any = [];
  selectedCheckRequiredForValueExp: any = [];
  checkRequiredForListDropdown: any = [];
  checkRequiredForRequiredMsg: any;
  ownerFieldRequiredMsg: any;
  dueDateRequiredMsg: any = [];
  dropDownDataForCheckRequiredFor: any = [];
  selectedGroupValue: any = null;
  groupValueDropdown: any = [];
  groupdataList: any = [];

  selectBoxForCheckRequiredFor() {
    this.checkRequiredForListDropdown = [];
    for (const element of this.dropDownDataForCheckRequiredFor) {
      this.checkRequiredForListDropdown = this.checkRequiredForListDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  onCheckRequiredForSelect(item: any) {
    if (this.checkRequiredForRequiredMsg != undefined) {
      this.checkRequiredForRequiredMsg.style.color = '#005c8a';
    }
  }

  onCheckRequiredForRemoved(item: any) {
    if (this.checkRequiredForRequiredMsg != undefined) {
      this.checkRequiredForRequiredMsg.style.color = 'red';
    }
  }

  selectedOutcome: any = [];
  outcomeListDropdown: any = [];
  selectBoxForOutcome() {
    this.outcomeListDropdown = [];
    for (const element of this.dropDownDataForOutcome) {
      this.outcomeListDropdown = this.outcomeListDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  selectedMethodology: any = [];
  methodologyListDropdown: any = [];
  selectBoxForMethodology() {
    this.methodologyListDropdown = [];
    for (const element of this.dropDownDataForMethodology) {
      this.methodologyListDropdown = this.methodologyListDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }
  //selectedOwner: any = [];
  ownerListDropdown: any = [];
  selectBoxForOwner() {
    this.ownerListDropdown = [];
    for (const element of this.dropDownForOwner) {
      this.ownerListDropdown = this.ownerListDropdown.concat({
        valueExp: element.userId,
        displayExp: element.userName
      });
    }
  }

  onOwnerSelect(item: any) {
    if (this.ownerFieldRequiredMsg != undefined) {
      this.ownerFieldRequiredMsg.style.color = '#005c8a';
    }
  }

  onOwnerRemoved(item: any) {
    if (this.ownerFieldRequiredMsg != undefined) {
      this.ownerFieldRequiredMsg.style.color = 'red';
    }
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY'
  dueDatePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    minDate: new Date()
  }

  dueDateOnChanged(items: any) {
    if (items != null || items != undefined) {
      this.dueDateRequiredMsg.style.color = '#005c8a';
    } else {
      this.dueDateRequiredMsg.style.color = 'red';
    }
  }

  fieldValidation() {

    this.checkRequiredForRequiredMsg = document.getElementById('checkRequiredFor-validation') as HTMLInputElement;
    this.ownerFieldRequiredMsg = document.getElementById('ownerField-validation') as HTMLInputElement;
    this.dueDateRequiredMsg = document.getElementById('dueDate-validation') as HTMLInputElement;

    if (this.selectedCheckRequiredFor.length < 1) {
      this.checkRequiredForRequiredMsg.style.color = 'red';
    } else {
      this.checkRequiredForRequiredMsg.style.color = '#005c8a';
    }

    if (this.selectedOwner.length < 1) {
      this.ownerFieldRequiredMsg.style.color = 'red';
    } else {
      this.ownerFieldRequiredMsg.style.color = '#005c8a';
    }

    if (this.ecData.dueDate) {
      this.dueDateRequiredMsg.style.color = '#005c8a';
    } else {
      this.dueDateRequiredMsg.style.color = 'red';
    }
  }

  addFunction(ecData: any) {
    if (this.selectedCheckRequiredFor.length < 1 || this.selectedOwner.length < 1 || this.ecData.dueDate == null) {
      this.fieldValidation();
      alert('Please enter the all mandatory fields...');
    } else {
      this.isProcessing = true;
      ecData.module = this.qualityService.moduleName;
      ecData.refNo = this.qualityService.activityId;
      ecData.remindNDaysBeforeDueDate = this.ecData.remindNDaysBeforeDueDate;
      if (this.selectedCheckRequiredFor.length > 0) {
        ecData.checkReqdFor = this.selectedCheckRequiredFor[0].valueExp;
      } else {
        ecData.checkReqdFor = null;
      }
      if (this.selectedOwner.length > 0) {
        ecData.owner = this.selectedOwner[0].valueExp;
      } else {
        ecData.owner = null;
      }
      if (this.ecData.dueDate) {
        ecData.dueDate = new Date(this.ecData.dueDate);
      } else {
        ecData.dueDate = null;
      }
      this.appService.createQmsTasksEC(this.ecData).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.visibleAddPopup.close();
            this.tasksEcComponent.getcallMethod();
          }
          this.showSnackBar(Response.result, Response.resultType);
          this.isProcessing = false;
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddPopup.close();
  }

  deleteReasonFieldValue: any;
  deleteReasonValidation() {
    this.passwordFieldValue = document.getElementById('password-validation') as HTMLInputElement;
    this.deleteReasonFieldValue = document.getElementById('deleteReason-validation') as HTMLInputElement;
    if (localStorage.getItem("adEnabled") != 'Y') {
      if (this.password == "") {
        this.passwordFieldValue.style.color = 'red';
      } else {
        this.passwordFieldValue.style.color = '#005c8a';
      }
    }

    if (this.reason == '' || this.reason == null || this.reason == undefined) {
      this.deleteReasonFieldValue.style.color = 'red';
    } else {
      this.deleteReasonFieldValue.style.color = '#005c8a';
    }
  }

  onFieldFocusout() {
    if (this.deleteReasonFieldValue != undefined) {
      if (this.reason == "" || this.reason == undefined || this.reason == null) {
        this.deleteReasonFieldValue.style.color = 'red';
      } else {
        this.deleteReasonFieldValue.style.color = '#005c8a';
      }
    }
  }

  performQualityBtnOperation(formData: FormData) {
    this.appService.performQualityBtnOperation(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      if (Response.resultType == "S") {
        this.visibleConfirmWithReason.close();
        this.isProcessing = true;
        if (this.qualityService.moduleName == "CR") {
          this.cRComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "CAPA") {
          this.capaComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "DV") {
          this.dvComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "IN") {
          this.inComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "QI") {
          this.qiComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "CC") {
          this.ccComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "OOS") {
          this.oosComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "AU") {
          if (this.qualityService.auditEditmodeDatas.pageName == "Conduct Audit") {
            this.auDetailPageComponent.ngOnInit();
          } else if (this.auService.auditPageFrom == "Main") {
            //this.auComponent.ngOnInit();
            this.auComponent.openEditPopup(0, 0, 0);
          } else {
            this.auComponent.cancelAddAndEditFunction();
          }
        }
      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        //duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })
  }

  confirmWithReasonFunc() {
    this.isProcessing = true;
    if (this.reason == null || this.reason == "" || (this.buttonLabel == 'Delete' && ((this.password == "" || this.password == null) && localStorage.getItem("adEnabled") != 'Y'))) {
      this.deleteReasonValidation();
      alert('Please enter the mandatory field...');
      this.isProcessing = false;
    } else if (localStorage.getItem("adEnabled") == 'Y') {
      this.authEnable("confirmWithReasonFunc");
    } else {
      let data = {
        userName: this.userName,
        password: this.password,
      }
      this.isProcessing = true;
      this.appService.validateUser(data).subscribe((data: any) => {
        if (data.resultType == "S") {
          let data = {
            moduleName: this.qualityService.moduleName,
            taskNo: this.qualityService.activityId,
            status: this.qualityService.activity.status,
            stageName: this.qualityService.activityButtonLabels.stageName,
            buttonValue: this.buttonLabel,
            actionStatus: null,
            comments: this.reason,
            rejectReason: null,
            reasonForSignature: null,
            fileExtn: null,
          }
          if (this.buttonListWithoutStages.includes(this.buttonLabel)) {
            data.stageName = null;
          }
          const formData = new FormData();
          const emptyfile: any = null;
          formData.append('file', emptyfile);
          const json = JSON.stringify(data);
          const blob = new Blob([json], {
            type: 'application/json'
          });
          formData.append('object', blob);
          this.performQualityBtnOperation(formData);
        } else {
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            //duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }
      })
    }
  }

  cancelFunc() {
    this.visibleConfirmWithReason.close();
  }

  cancelSwitchGroup() {
    this.visibleswitchGroupPopup.close();
  }

  switchGroupBtn() {
    if (this.selectedGroupValue) {
      this.isProcessing = true;

      const data = {
        groupId: this.selectedGroupValue ?? null,
        ...(this.qualityService.moduleName == "IN" ? { inNo: this.qualityService.activityId } : { ccNo: this.qualityService.activityId })
      };

      const methods = {
        switchOperationIncident: () => this.appService.switchOperationIncident(data),
        switchComplaintGroup: () => this.appService.switchComplaintGroup(data)
      };

      const methodName = this.qualityService.moduleName == "IN" ? 'switchOperationIncident' : 'switchComplaintGroup';

      methods[methodName]().subscribe({
        next: (Response: any) => {
          if (Response.resultType === 'S') {
            this.qualityService.moduleName == "IN" ? this.router.navigate(['dashboard/ActivityCR', "IN"]) : this.router.navigate(['dashboard/ActivityCR', "CC"]);
            this.visibleswitchGroupPopup.close();
          }
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        },
        error: (error: Error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      this.showSnackBar("Please select the Group", 'E');
    }
  }

  cancelConfirmWithDataFunc() {
    this.visibleConfirmWithData.close();
  }

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  private updateTaskStageUsers(checkListEnabled: boolean, checkListSkipped: boolean, callback?: () => void): void {
    delete this.stageUserStageDetails['updatedOn'];
    const obj = {
      ...this.stageUserStageDetails,
      completedOn: this.stageUserStageDetails['completedOn'] ? new Date(this.stageUserStageDetails['completedOn']) : null,
      requestedOn: this.stageUserStageDetails['requestedOn'] ? new Date(this.stageUserStageDetails['requestedOn']) : null,
      isCheckListEnabled: checkListEnabled ? "Y" : "N",
      isCheckListSkipped: checkListSkipped ? "Y" : "N",
      refDetails: this.stageUserStageDetails.taskStageUsersPk.refDetails,
      refNo: this.stageUserStageDetails.taskStageUsersPk.refNo,
      slNo: this.stageUserStageDetails.taskStageUsersPk.slNo,
      stageName: this.stageUserStageDetails.taskStageUsersPk.stageName,
      userId: this.stageUserStageDetails.taskStageUsersPk.userId,
      version: 0,
    }
    this.appService.updateTaskStageUser(obj).subscribe({
      next: (Response: any) => {
        callback?.();
      },
      error: (error) => {
        callback?.();
        this.isProcessing = false;
        throw error;
      }
    });
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const flag: boolean = fieldId == 'Replace this string with Multi select Id' ? items.length : items;

    field && (field.style.color = flag ? '#005c8a' : 'red');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  checkListDeletionArray: any = [];
  confirmWithDataFunc() {
    if ((this.isCheckListEnabled && !this.isCheckListSkippable) || (this.isCheckListEnabled && this.isCheckListSkippable && !this.isSkipped)) {
      this.isProcessing = true;
      this.appService.getAllCheckList(this.qualityService.activityId, this.qualityService.activityButtonLabels.stageName.split('<')[0]).subscribe((checkList: any) => {
        const array: any[] = checkList;
        if (array.length) {
          const mandatoryList = array?.filter((field: any) => { return !field.justification || !field.response; });
          this.isProcessing = false;
          if (mandatoryList.length) {
            setTimeout(() => {
              this.onNgModelChange(!mandatoryList.length, 'check-list');
              this.showSnackBar('Please confirm all CheckList!', 'E');
            }, 100);
          } else {
            this.onNgModelChange(true, 'check-list')
            this.updateTaskStageUsers(this.isVerifyingCheckList, this.isSkipped, () => this.execute());
          }
        } else {
          this.isProcessing = false;
          setTimeout(() => {
            this.onNgModelChange(array.length, 'check-list');
            this.showSnackBar('Please execute CheckList!', 'E');
          }, 100);
        }
      })
    } else if (this.isCheckListEnabled && this.isCheckListSkippable && this.isSkipped) {
      this.isProcessing = true;
      this.appService.getAllCheckList(this.qualityService.activityId, this.qualityService.activityButtonLabels.stageName.split('<')[0]).subscribe((checkList: any) => {
        this.checkListDeletionArray = checkList;
        this.onNgModelChange(true, 'check-list');
        this.execute();
      })
    } else {
      this.onNgModelChange(true, 'check-list');
      this.execute();
    }
  }

  execute() {
    this.isProcessing = true;
    if (this.qualityService.moduleName == 'AU' && (this.buttonLabel == "Send Q&A Response" || this.buttonLabel == 'More Info. Required On Q&A Responses') && this.auDetailPageComponent.selectedTabIndex == 1) this.auDetailPageComponent.selectedTabIndex = 0;
    let list = [];
    if (this.orgData.allowedFileExtns) {
      list = this.orgData.allowedFileExtns.split(",");
    };
    if (!list.includes(this.fileExtn.toUpperCase()) && this.buttonOperationFile != null) {
      this.isProcessing = false;
      this.showSnackBar("File extension " + this.fileExtn + " is not allowed.", "E");
    }
    else if ((localStorage.getItem("adEnabled") != 'Y' && this.password == "")
      //  ||this.statusDropdown.length==0?(this.buttonLabel.includes('More Info')||this.buttonLabel.includes('Reject')||this.buttonLabel.includes('Revoke')):(this.selectedStatus?.includes('More Info')||this.selectedStatus?.includes('Reject'))&& this.comments == ""
      || ((this.statusDropdown.length == 0 ? (this.buttonLabel.includes('More Info') || this.buttonLabel.includes('Reject') || this.buttonLabel.includes('Revoke')) : this.selectedStatus?.includes('More Info') || this.selectedStatus?.includes('Rejected')) && this.comments == "")
      || (this.selectedReason.length == 0 && this.isReasonSignReqd)) {
      this.buttonOperationFieldValidation();
      this.showSnackBar("Please enter the all mandatory fields...", "E");
      this.isProcessing = false;
    } else if (this.isEsignRequired && localStorage.getItem("adEnabled") != 'Y') {
      let data = {
        userName: this.userName,
        password: this.password,
      }
      this.isProcessing = true;
      this.appService.validateUser(data).subscribe((data: any) => {
        if (data.resultType == "S") {
          this.isProcessing = true;
          if ((this.selectedReasonValue.includes('More Info') || this.selectedStatusValue.includes('Reject')) && (this.comments == null || this.comments == "")) {
            this.buttonOperationFieldValidation();
            alert('Please enter the all mandatory fields...');
            this.isProcessing = false;
          } else {
            let data = {
              moduleName: this.qualityService.moduleName,
              taskNo: this.qualityService.activityId,
              status: this.qualityService.activity.status,
              stageName: this.qualityService.activityButtonLabels.stageName,
              buttonValue: this.buttonLabel,
              actionStatus: this.selectedStatusValue,
              comments: this.comments,
              rejectReason: this.selectedRejectReasonValue,
              reasonForSignature: this.selectedReasonValue,
              fileExtn: this.fileExtn,
            }
            console.log(this.buttonListWithoutStages.includes(this.buttonLabel));
            if (this.buttonListWithoutStages.includes(this.buttonLabel)) {
              data.stageName = null;
            }
            const formData = new FormData();
            formData.append('file', this.buttonOperationFile);
            const json = JSON.stringify(data);
            const blob = new Blob([json], {
              type: 'application/json'
            });
            formData.append('object', blob);

            if (!this.fileName) {
              this.performOperationAndRefresh(formData);
              return;
            }

            this.addDocsToFilesTab({
              docName: this.fileName + "_" + this.qualityService.activityButtonLabels.stageName, docExtension: this.fileExtn, comments: this.comments
            }, formData, '', 'performOperationAndRefresh');
          }
        } else {
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            //duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }
      })
    } else if (this.isEsignRequired && localStorage.getItem("adEnabled") == 'Y') {
      this.checkListDeletionArray.length && this.deleteMethod();
      this.authEnable("confirmWithDataFunc");
    } else {
      this.isProcessing = true;
      if ((this.selectedReasonValue.includes('More Info') || this.selectedStatusValue.includes('Reject')) && (this.comments == null || this.comments == "")) {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        this.checkListDeletionArray.length && this.deleteMethod();
        let data = {
          moduleName: this.qualityService.moduleName,
          taskNo: this.qualityService.activityId,
          status: this.qualityService.activity.status,
          stageName: this.qualityService.activityButtonLabels.stageName,
          buttonValue: this.buttonLabel,
          actionStatus: this.selectedStatusValue,
          comments: this.comments,
          rejectReason: this.selectedRejectReasonValue,
          reasonForSignature: this.selectedReasonValue,
          fileExtn: this.fileExtn,
        }
        console.log(this.buttonListWithoutStages.includes(this.buttonLabel));
        if (this.buttonListWithoutStages.includes(this.buttonLabel)) {
          data.stageName = null;
        }
        const formData = new FormData();
        formData.append('file', this.buttonOperationFile);
        const json = JSON.stringify(data);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        formData.append('object', blob);

        if (!this.fileName) {
          this.xyz(formData);
          return;
        }

        this.addDocsToFilesTab({
          docName: this.fileName + "_" + this.qualityService.activityButtonLabels.stageName, docExtension: this.fileExtn, comments: this.comments
        }, formData, '', 'xyz');
      }
    }
  }

  performOperationAndRefresh(formData: FormData) {
    this.appService.performQualityBtnOperation(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      if (Response.resultType == "S") {
        this.checkListDeletionArray.length && this.deleteMethod();
        this.visibleConfirmWithData.close();
        if (this.qualityService.moduleName == "CR") {
          this.cRComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "CAPA") {
          this.capaComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "DV") {
          this.dvComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "IN") {
          this.inComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "QI") {
          this.qiComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "CC") {
          this.ccComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "OOS") {
          this.oosComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "AU") {
          if (this.qualityService.auditEditmodeDatas.pageName == "Conduct Audit") {
            this.auDetailPageComponent.ngOnInit();
          } else if (this.auService.auditPageFrom == "Main") {
            //this.auComponent.ngOnInit();
            this.auComponent.openEditPopup(0, 0, 0);
          } else {
            this.auComponent.cancelAddAndEditFunction();
            this.auComponent.cancelAddAndEditFunction();
          }
          //
        }
        this.isProcessing = true;
      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        //duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })
  }

  xyz(formData: FormData) {
    this.appService.performQualityBtnOperation(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      if (Response.resultType == "S") {
        this.visibleConfirmWithData.close();
        if (this.qualityService.moduleName == "CR") {
          this.cRComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "CAPA") {
          this.capaComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "DV") {
          this.dvComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "IN") {
          this.inComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "QI") {
          this.qiComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "CC") {
          this.ccComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "OOS") {
          this.oosComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "AU") {
          if (this.qualityService.auditEditmodeDatas.pageName == "Conduct Audit") {
            this.auDetailPageComponent.ngOnInit();
          } else if (this.auService.auditPageFrom == "Main") {
            //this.auComponent.ngOnInit();
            this.auComponent.openEditPopup(0, 0, 0);
          } else {
            this.auComponent.cancelAddAndEditFunction();
          }
        }
        this.isProcessing = true;
      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        //duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })
  }

  private addDocsToFilesTab(doc: FilesTab, formData: FormData, section: string, functionName: string): void {
    const obj = {
      operation: 'I',
      refNo: this.qualityService.activityId,
      module: this.qualityService.moduleName,
      documentType: 'Evidence',
      documentName: doc.docName,
      documentExtn: doc.docExtension,
      comments: doc.comments,
    };
    const qmsTaskDocumentsData = new FormData();
    qmsTaskDocumentsData.append('file', this.buttonOperationFile);
    const json = JSON.stringify(obj);
    const blob = new Blob([json], {
      type: 'application/json'
    });
    qmsTaskDocumentsData.append('qmsTaskDocumentsVwDto', blob);
    this.appService.createQmsTaskDocuments(qmsTaskDocumentsData).subscribe((response: any) => {
      if (response.resultType === 'E') {
        this.showSnackBar(response.result, 'E');
        this.isProcessing = false;
        return;
      }

      if (functionName == 'proceedOperation') {
        this.proceedOperation(formData, section);
      } else if (functionName == 'performOperationAndRefresh') {
        this.performOperationAndRefresh(formData);
      }
    });
  }

  statusFiledValue: any;
  rejectReasonFieldValue: any;
  reasonForSignatureFieldValue: any;
  commentsFieldValue: any;
  buttonOperationFieldValidation() {
    this.statusFiledValue = document.getElementById('status-validation') as HTMLInputElement;
    this.passwordFieldValue = document.getElementById('password-validation') as HTMLInputElement;
    this.reasonForSignatureFieldValue = document.getElementById('reasonForSignature-validation') as HTMLInputElement;
    this.commentsFieldValue = document.getElementById('comment-validation') as HTMLInputElement;
    if (localStorage.getItem("adEnabled") != 'Y') {
      if (this.password == "") {
        this.passwordFieldValue.style.color = 'red';
      } else {
        this.passwordFieldValue.style.color = '#005c8a';
      }
    }
    if (this.statusDropdown.length > 0) {
      if (this.selectedStatus == null) {
        this.statusFiledValue.style.color = 'red';
      } else {
        this.statusFiledValue.style.color = '#005c8a';
        if (this.selectedStatus == "Review Rejected" || this.selectedStatus == "Approval Rejected") {
          if (!this.selectedRejectReason) {
            if (this.rejectReasonFieldValue) {
              this.rejectReasonFieldValue.style.color = 'red';
            }

          } else if (this.rejectReasonFieldValue) {
            this.rejectReasonFieldValue.style.color = '#005c8a';
          }
        }
      }
    }
    if (this.selectedReason.length == 0) {
      if (this.reasonForSignatureFieldValue != null) {
        if (this.reasonForSignatureFieldValue) {
          this.reasonForSignatureFieldValue.style.color = 'red';
        }
      }
    } else if (this.reasonForSignatureFieldValue) {
      this.reasonForSignatureFieldValue.style.color = '#005c8a';
    }

    if (this.comments == null || this.comments == "") {
      if (this.commentsFieldValue != null) {
        this.commentsFieldValue.style.color = 'red';
      }
    } else {
      this.commentsFieldValue.style.color = '#005c8a';
    }
  }

  confirmValidationOkFunc() {
    this.visibleValidationConfirm.close();
    this.isEsignRequired = true;
    this.password = "";
    this.visibleConfirm = this.dialog.open(this.confirmPopup, this.confirmPopupConfig);
  };

  cancelValidationConfirmFunc() {
    this.visibleValidationConfirm.close();
  };

  passwordFieldValue: any;
  commentFieldValue: any;
  dynamicButtonFieldValidation() {
    this.passwordFieldValue = document.getElementById('password-validation') as HTMLInputElement;
    this.commentFieldValue = document.getElementById('comment-validation') as HTMLInputElement;

    if (this.password == '' || this.password == undefined || this.password == null) {
      this.passwordFieldValue.style.color = 'red';
    } else {
      this.passwordFieldValue.style.color = '#005c8a';
    }

    if ((this.selectedReasonValue?.includes('More Info') || this.selectedStatusValue?.includes('Reject')) && this.comments == "" || this.comments == null) {
      this.commentFieldValue.style.color = 'red';
    } else {
      this.commentFieldValue.style.color = '#005c8a';
    }
  }

  onPasswordFieldFocusout() {
    this.passwordFieldValue = document.getElementById('password-validation') as HTMLInputElement;
    this.commentsFieldValue = document.getElementById('comment-validation') as HTMLInputElement;

    if (this.passwordFieldValue != undefined) {
      if (this.password == '' || this.password == undefined || this.password == null) {
        this.passwordFieldValue.style.color = 'red';
      } else {
        this.passwordFieldValue.style.color = '#005c8a';
      }
    }

    if ((this.selectedReasonValue?.includes('More Info') || this.selectedStatusValue?.includes('Reject')) && this.commentsFieldValue != undefined) {
      if (this.comments == '' || this.comments == undefined || this.comments == null) {
        this.commentsFieldValue.style.color = 'red';
      } else {
        this.commentsFieldValue.style.color = '#005c8a';
      }
    }
  }

  authEnable(flag: string) {
    this.authService.loginPopup({
      scopes: ["User.Read"],
      prompt: "login"
    })
      .subscribe({
        next: (result) => {
          console.log(result.account?.username);
          let oldlooginuser = localStorage.getItem("loggedUserName")?.toUpperCase();
          let newuser = result.account?.username.toUpperCase();
          if (oldlooginuser === newuser) {
            console.log("inside");
            if (flag == "confirmOkFunc") {
              let data = {
                moduleName: this.qualityService.moduleName,
                taskNo: this.qualityService.activityId,
                status: this.qualityService.activity.status,
                stageName: this.qualityService.activityButtonLabels.stageName,
                buttonValue: this.buttonLabel,
                actionStatus: this.selectedStatusValue,
                comments: this.comments,
                rejectReason: this.selectedRejectReasonValue,
                reasonForSignature: this.selectedReasonValue,
                fileExtn: this.fileExtn,
              }
              if (this.buttonListWithoutStages.includes(this.buttonLabel)) {
                data.stageName = null;
              }
              const formData = new FormData();
              formData.append('file', this.buttonOperationFile);
              const json = JSON.stringify(data);
              const blob = new Blob([json], {
                type: 'application/json'
              });
              formData.append('object', blob);

              this.confirmOkFuncSuccessPart(formData, "confirmOkFunc");

            } else if (flag == "confirmWithReasonFunc") {
              let data = {
                moduleName: this.qualityService.moduleName,
                taskNo: this.qualityService.activityId,
                status: this.qualityService.activity.status,
                stageName: this.qualityService.activityButtonLabels.stageName,
                buttonValue: this.buttonLabel,
                actionStatus: null,
                comments: this.reason,
                rejectReason: null,
                reasonForSignature: null,
                fileExtn: null,
              }
              if (this.buttonListWithoutStages.includes(this.buttonLabel)) {
                data.stageName = null;
              }
              const formData = new FormData();
              formData.append('file', this.buttonOperationFile);
              const json = JSON.stringify(data);
              const blob = new Blob([json], {
                type: 'application/json'
              });
              formData.append('object', blob);

              this.confirmOkFuncSuccessPart(formData, "confirmWithReasonFunc");
            } else if (flag == "confirmWithDataFunc") {
              let data = {
                moduleName: this.qualityService.moduleName,
                taskNo: this.qualityService.activityId,
                status: this.qualityService.activity.status,
                stageName: this.qualityService.activityButtonLabels.stageName,
                buttonValue: this.buttonLabel,
                actionStatus: this.selectedStatusValue,
                comments: this.comments,
                rejectReason: this.selectedRejectReasonValue,
                reasonForSignature: this.selectedReasonValue,
                fileExtn: this.fileExtn,
              }
              if (this.buttonListWithoutStages.includes(this.buttonLabel)) {
                data.stageName = null;
              }
              const formData = new FormData();
              formData.append('file', this.buttonOperationFile);
              const json = JSON.stringify(data);
              const blob = new Blob([json], {
                type: 'application/json'
              });
              formData.append('object', blob);
              this.confirmOkFuncSuccessPart(formData, "confirmWithDataFunc");
            }
          } else {
            console.log("outside");
          }
        },
        error: (error) => {
          this.isProcessing = false;
          console.log(error);

        }
      });
  }

  confirmOkFuncSuccessPart(formData: FormData, section: string) {
    if (!this.fileName) {
      this.proceedOperation(formData, section);
      return;
    }

    this.addDocsToFilesTab({
      docName: this.fileName + "_" + this.qualityService.activityButtonLabels.stageName, docExtension: this.fileExtn, comments: this.comments
    }, formData, section, 'proceedOperation');
  }


  proceedOperation(formData: FormData, section: string) {
    this.appService.performQualityBtnOperation(formData).subscribe((Response: any) => {
      this.isProcessing = false;

      this.showSnackBar(Response.result, Response.resultType);
      if (Response.resultType == "S") {
        if (section == "confirmWithDataFunc") {
          this.visibleConfirmWithData.close();
        } else if (section == "confirmOkFunc") {
          this.visibleConfirm.close();

        } else if (section == "confirmWithReasonFunc") {
          this.visibleConfirmWithReason.close();
        }
        this.qualityService.refereshBreadCrumb = false;
        if (this.qualityService.moduleName == "CR") {
          this.cRComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "CAPA") {
          this.capaComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "DV") {
          this.dvComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "IN") {
          this.inComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "QI") {
          this.qiComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "CC") {
          this.ccComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "OOS") {
          this.oosComponent.ngOnInit();
        } else if (this.qualityService.moduleName == "AU") {
          if (this.qualityService.auditEditmodeDatas.pageName == "Conduct Audit") {
            this.auDetailPageComponent.ngOnInit();

          } else if (this.auService.auditPageFrom == "Main") {
            //this.auComponent.ngOnInit();
            this.auComponent.openEditPopup(0, 0, 0);
          } else {
            this.auComponent.cancelAddAndEditFunction();
          }
        }
      }
      this.isProcessing = false;
    })
  }

  confirmOkFunc() {
    if (this.qualityService.moduleName == 'AU' && (this.buttonLabel == "Send Q&A Response" || this.buttonLabel == 'More Info. Required On Q&A Responses') && this.auDetailPageComponent.selectedTabIndex == 1) this.auDetailPageComponent.selectedTabIndex = 0;
    if (localStorage.getItem("adEnabled") == 'Y') {
      this.authEnable("confirmOkFunc");
    } else if ((this.isEsignRequired && this.password == '')
      || (this.buttonLabel.includes('Rejec') || this.buttonLabel.includes('More Info') && (this.comments == "" || this.comments == null))) {
      this.dynamicButtonFieldValidation();
      alert('Please enter the mandatory field...');
    } else {
      let data = {
        userName: this.userName,
        password: this.password,
      }
      this.isProcessing = true;
      this.appService.validateUser(data).subscribe((data: any) => {
        if (data.resultType == "S") {
          this.isProcessing = true;
          let data = {
            moduleName: this.qualityService.moduleName,
            taskNo: this.qualityService.activityId,
            status: this.qualityService.activity.status,
            stageName: this.qualityService.activityButtonLabels.stageName,
            buttonValue: this.buttonLabel,
            actionStatus: this.selectedStatusValue,
            comments: this.comments,
            rejectReason: this.selectedRejectReasonValue,
            reasonForSignature: this.selectedReasonValue,
            fileExtn: this.fileExtn,
          }
          console.log(this.buttonListWithoutStages.includes(this.buttonLabel));
          if (this.buttonListWithoutStages.includes(this.buttonLabel)) {
            data.stageName = null;
          }
          const formData = new FormData();
          formData.append('file', this.buttonOperationFile);
          const json = JSON.stringify(data);
          const blob = new Blob([json], {
            type: 'application/json'
          });
          formData.append('object', blob);

          this.confirmOkFuncSuccessPart(formData, "confirmOkFunc");

        } else {
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            //duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }
      })
    }
  }

  cancelConfirmFunc() {
    this.visibleConfirm.close();
  }

  callQmsAuVwUpdateFunction() {
    if (this.qualityService.auditEditmodeDatas.pageName == "Conduct Audit") {
      this.auDetailPageComponent.update();
    } else {
      this.auComponent.addAndEditFunction();
    }
  }

  callQmsCrVwUpdateFunction() {
    if (this.qualityService.activitySaveButton) {
      this.cRComponent.update();
    }
  }

  callQmsCapaVwUpdateFunction() {
    this.capaComponent.update();
  }

  callQmsDvVwUpdateFunction() {
    this.dvComponent.update();
  }

  triggerIncidentUpdate() {
    this.inComponent.update()
  }

  validateOos(clickedButton: any): Promise<boolean> {
    return new Promise<boolean>((resolve) => {

      this.qualityService.validatedOosArray = [];
      let validationPromises: Promise<void>[] = [];

      Promise.all(validationPromises).then(() => {
        const isValid = !this.qualityService.validatedOosArray.includes('Failed')
        resolve(isValid);
      }).catch((error) => {
        console.error('Error occurred during validation:', error);
        resolve(false);
      });
    });
  }

  triggerQiUpdate() {
    this.qiComponent.update();
  }

  triggerCcUpdate() {
    this.ccComponent.update();
  }

  triggerOosUpdate() {
    this.oosComponent.update();
  }

  validateAudit(clickedButton: any): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.qualityService.validatedAuArray = [];
      this.qualityService.isUpdatingAuThroughDynBtn = true;
      let validationPromises: Promise<void>[] = [];

      validationPromises.push(this.auComponent.validateAudit(), this.auComponent.validateQuestionnaire(), this.auComponent.validateAuditFlexiFields());

      Promise.all(validationPromises).then(() => {
        const isValid = !this.qualityService.validatedAuArray.includes('Failed')
        resolve(isValid);
      }).catch((error) => {
        console.error('Error occurred during validation:', error);
        resolve(false);
      });
    });
  }

  getFailedCount(): number {
    return this.qualityService.validatedAuArray.filter((e: any) => e.includes('Failed')).length;
  }

  getFailedConditionMet(): number {
    return this.qualityService.validatedAuArray.filter((e: any) => e.includes('Failed')).length == 1 && this.auComponent.selectedTab == 'Audit Plan' && this.qualityService.activity.questionAndAnswerSectionType && !this.auService.questionnaireList.length;
  }

  @ViewChild('mandatoryPopup', { static: true }) mandatoryPopup: TemplateRef<any>;
  visibleMandatoryPopup: MatDialogRef<TemplateRef<any>>;

  mandatoryPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  closeMandatoryPopup() {
    this.visibleMandatoryPopup.close();
  }

  @ViewChild('dependencyAlertPopup', { static: true }) dependencyAlertPopup: TemplateRef<any>;
  visibledDependencyAlertPopup: MatDialogRef<TemplateRef<any>>;
  dependencyTriggredButton: string = '';

  dependencyAlertPopupPopupConfig = {
    width: '850px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  proceedWithOpenDependencies() {
    const moduleKey = this.qualityService.moduleName as keyof typeof processMapping;

    const saveMapping =
      { 'CR': 'cRComponent', 'CAPA': 'capaComponent', 'DV': 'dvComponent', 'IN': 'inComponent', 'QI': 'qiComponent', 'CC': 'ccComponent', 'OOS': 'oosComponent' } as const;
    const processMapping =
      { 'CR': 'isUpdatingCrThroughDynBtn', 'CAPA': 'isUpdatingCapaThroughDynBtn', 'DV': 'isUpdatingDvThroughDynBtn', 'IN': 'isUpdatingIncidentThroughDynBtn', 'QI': 'isUpdatingQiThroughDynBtn', 'CC': 'isUpdatingCcThroughDynBtn', 'OOS': 'isUpdatingOosThroughDynBtn' } as const;

    if (this.qualityService.moduleName != 'AU' && this.qualityService.moduleName != 'OOS') {
      this.qualityService[processMapping[moduleKey]] = true;
      this[saveMapping[moduleKey]].update();
    }
    this.visibledDependencyAlertPopup.close();
    this.isEsignRequired = true;
    this.password = "";
    this.title = this.dependencyTriggredButton;
    this.visibleConfirm = this.dialog.open(this.confirmPopup, this.confirmPopupConfig);
  }

  closeDependencyAlertPopup() {
    this.visibledDependencyAlertPopup.close();
  }

  confirmQiSeriousBreach() {
    this.visibleQiSeriousBreachPopup.close();
    this.visibleConfirm = this.dialog.open(this.confirmPopup, this.confirmPopupConfig);
  };

  goToFiles() {
    this.visibleQiSeriousBreachPopup.close();
    this.qiComponent.selectedTabIndex = 1;
    this.qualityService.landToDocumentsAutomatically = true;
  }

  @ViewChild('qiSeriousBreach', { static: true }) qiSeriousBreach: TemplateRef<any>;
  visibleQiSeriousBreachPopup: MatDialogRef<TemplateRef<any>>;

  qiSeriousBreachPopupConfig = {
    width: '550px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  closeQiSeriousBreachPopup() {
    this.visibleQiSeriousBreachPopup.close();
  }

  changeTypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changeTypeAddAndEditPassword = !this.changeTypeAddAndEditPassword;
  }

  showCheckList: boolean = false;
  checkList: CheckListConfig;
  @ViewChild(ChecklistComponent) checklistComponent!: ChecklistComponent;
  public openCheckListPopup(): void {
    const stageName = this.qualityService.activityButtonLabels.stageName.split('<')[0];
    const x = this.qualityService.selectedGroupDetailData;

    this.checkList = {
      refNo: this.qualityService.activityId, stageName,
      templateIds: ((stageName == 'Review' || stageName == 'Peer Review' || stageName == 'PhaseII Review' || stageName == 'PhaseIII Review') && x.reviewCheckListTemplateIds) || ((stageName == 'Approve' || stageName == 'PhaseIII Review' || stageName == 'PhaseIII Approve') && x.approveCheckListTemplateIds) || (stageName == 'Closure Review' && x.closureReviewCheckListTemplateIds) || (stageName == 'Closure Approve' && x.closureApproveCheckListTemplateIds)
    };
    this.showCheckList = true;
  }

  public onPopupClosed(): void {
    this.showCheckList = false;
  }

  responses: any = [];
  deleteMethod() {
    this.isProcessing = true;
    this.responses = [];

    from(this.checkListDeletionArray).pipe(
      concatMap((field: any, index: number) => {

        const obj = {
          fieldId: field.fieldId,
          refNo: field.refNo,
          fieldName: field.fieldName,
          deleteReason: 'Changed Template'
        };

        console.log("Sending →", obj);

        return this.appService.deleteCheckList(obj).pipe(
          tap((response: any) => {
            this.responses[index] = { field, response: response, };
          }),
          catchError((error) => {
            console.error("Error while creating question:", error);
            this.showSnackBar("One item failed to create", "E");
            return of(null); /* Continue to next */
          })
        );
      }),
      finalize(() => {
        this.isProcessing = false;
      })
    ).subscribe();
  }

}
